import { call, select, delay, takeEvery } from 'redux-saga/effects';
import { logErrors as logErrorsAPI, logEvent as logEventAPI, logUserEvent as logUserEventAPI } from '../services/log';
import { getCookie, deleteCookie, setCookie } from '../utils';
import { LOG_EVENT, LOG_USER_EVENT } from '../actions/types';
// import { showErrorMsg } from "../actions/snackbar";

export function* logErrors(error, reqBody) {
  let errorData = [];
  try {
    const { mobile } = yield select((state) => state.user || {});
    if (error && reqBody) {
      errorData = [{error, reqBody}]
    }
    let errorLogs = getCookie('errorLogs');
    if(errorLogs) {
      errorData = [...JSON.parse(errorLogs), ...errorData];
    }
    yield call(logErrorsAPI, {
      user: `${mobile || 'guest'}-${window.navigator.userAgent}`,
      pwa: window && window.matchMedia('(display-mode: standalone)').matches,
      errorStack: errorData
    });

    deleteCookie('errorLogs');
  } catch (error) {
    setCookie('errorLogs', JSON.stringify(errorData));
    throw error;
  }
}

export function *watchLogger() {
  let retries = 0
  while (retries < 5) {
    try {
      let errorLogs = getCookie('errorLogs');
      if(errorLogs) {
        yield call(logErrors);
      }
      retries = 0;
    } catch (error) {
      retries++;
      console.error(error);
    }
    yield delay(30000);
  }
}

function *logEvent(action) {
  try {
    const { sessionId } = yield select((state) => state.auth || {});
    yield call(logEventAPI, action.payload, sessionId);
  } catch (error) {
    // yield put(showErrorMsg(error.message));
  }
};

function *logUserEvent(action) {
  try {
    yield call(logUserEventAPI, action.payload);
  } catch (error) {
    // yield put(showErrorMsg(error.message));
  }
};


export function *watchLog() {
	yield takeEvery(LOG_EVENT, logEvent);
	yield takeEvery(LOG_USER_EVENT, logUserEvent);
}